import { CustomData } from '@shared/models/project-setup';
import { convertTimeToDisplayFormat, parseTimeString } from '@shared/utils';
import jspreadsheet from 'jspreadsheet';

export const dateRegex = /^(\d{1,2})[^\d]+(\d{1,2})[^\d]+(\d{2,4})$/;
export const dateTimeRegex =
  /^(\d{1,2})[^\d]+(\d{1,2})[^\d]+(\d{2,4})\s+(\d{1,2}):(\d{2})$/;
/**
 * Special ASCII character ('─') used for read-only placeholders.
 * This character is visually similar to a dash but cannot be typed from the keyboard,
 * preventing users from bypassing validations.
 */
export const readOnlyPlaceholder = '─';
export const readOnlyBackgroundColor = '#f2f2f2';

export function findByValue<T>(source: T[], value: string): T | null {
  const target = value?.toLowerCase();

  return (
    source.find((item: any) => {
      if (item && typeof item === 'object') {
        return (
          item.name?.toString().toLowerCase() === target ||
          item.id?.toString().toLowerCase() === target
        );
      }

      return item?.toString().toLowerCase() === target;
    }) ?? null
  );
}

export function formatTimeToDisplayString(value: string): string {
  const original = value?.toString()?.trim();
  if (!original) return original;

  const parsed = parseTimeString(original);
  if (!parsed) return original;

  if (parsed.hours === '24' && parsed.minutes === '00') {
    return convertTimeToDisplayFormat('23:59:59');
  }

  return convertTimeToDisplayFormat(`${parsed.hours}:${parsed.minutes}`);
}

export function buildCustomDataColumnName(value: CustomData): string {
  return `cd_id_${value.id}_datatype_${value.dataTypeId}`;
}

export function parseCustomDataInfoFromColumnName(
  columnName: string
): { customDataId: number; dataTypeId: number } | null {
  const match = columnName.match(/cd_id_(\d+)_datatype_(\d+)/);
  if (!match) return null;
  return {
    customDataId: parseInt(match[1]),
    dataTypeId: parseInt(match[2]),
  };
}

export function isCellReadonly(
  worksheet: jspreadsheet.worksheetInstance,
  columnIndex: number,
  rowIndex: number
): boolean {
  const cellName = `${jspreadsheet.helpers.getColumnName(columnIndex)}${
    rowIndex + 1
  }`;
  const backgroundColor = worksheet
    .getStyle(cellName)
    ?.toString()
    ?.split(':')[1];

  return backgroundColor === readOnlyBackgroundColor;
}
